import * as styles from "./InputTextArea.css";
import { Input as AntdInput, InputProps as AntdInputProps } from "antd";
import { InputStatus } from "antd/es/_util/statusUtils";
import { SizeType } from "antd/es/config-provider/SizeContext";
import noop from "common/utils/universal/noop";
import { omit } from "ramda";
import { BaseInputProps } from "rc-input/lib/interface";
import { AutoSizeType, HTMLTextareaProps } from "rc-textarea/lib/interface";
import React, { CSSProperties, ForwardedRef } from "react";

type AntdBaseTextAreaProps = Omit<HTMLTextareaProps, "onResize"> & {
  prefixCls?: string;
  className?: string;
  style?: React.CSSProperties;
  autoSize?: boolean | AutoSizeType;
  onPressEnter?: React.KeyboardEventHandler<HTMLTextAreaElement>;
  onResize?: (size: { width: number; height: number }) => void;
  classes?: {
    countWrapper?: string;
    affixWrapper?: string;
  };
  classNames?: {
    textarea?: string;
    count?: string;
  };
  styles?: {
    textarea?: CSSProperties;
    count?: CSSProperties;
  };
} & Pick<BaseInputProps, "allowClear" | "suffix"> &
  Pick<AntdInputProps, "showCount" | "count">;

interface AntdTextAreaProps extends Omit<AntdBaseTextAreaProps, "suffix"> {
  change: AntdTextAreaProps["onChange"];
  bordered?: boolean;
  size?: SizeType;
  status?: InputStatus;
  rootClassName?: string;
  ref?: ForwardedRef<any>; //If you use this inside a form and have a separate component for your date picker, you'll need to use forwardRef inside that component in order for antd to see changes, validations, etc.
}

const { TextArea } = AntdInput;

const InputTextArea = React.forwardRef<HTMLTextAreaElement, AntdTextAreaProps>(
  ({ change = noop, onChange = noop, ...rest }) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      change(e);
      onChange(e);
    };
    return (
      <TextArea
        className={styles.customAntdTextArea}
        maxLength={255}
        onChange={handleChange}
        {...omit(["onChange"], rest as AntdTextAreaProps)}
      />
    );
  }
);

export default InputTextArea;
